export default "__VITE_ASSET__CGbWBRwu__"